<template>
  <nav aria-label="Progression" class="w-full">
    <ol class="flex items-start w-full">
      <li
        v-for="(step, index) in steps"
        :key="step.key"
        class="flex flex-col items-center"
        :class="index < steps.length - 1 ? 'flex-1' : ''"
      >
        <!-- Circle + connector row -->
        <div class="flex items-center w-full">
          <!-- Step circle -->
          <div
            class="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-all duration-300"
            :class="circleClasses(index)"
          >
            <CheckIcon v-if="statusFor(index) === 'completed'" class="h-4 w-4 text-white" />
            <span v-else class="text-xs font-semibold" :class="numberClasses(index)">{{ index + 1 }}</span>
          </div>
          <!-- Connector line -->
          <div
            v-if="index < steps.length - 1"
            class="flex-1 h-0.5 transition-colors duration-500"
            :class="index < currentIndex ? 'bg-indigo-600' : 'bg-gray-200'"
          />
        </div>
        <!-- Label -->
        <span
          class="mt-2 text-xs font-medium tracking-wide text-center w-9 transition-colors duration-300"
          :class="labelClasses(index)"
        >
          {{ step.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import { computed } from "vue";
import { CheckIcon } from "@heroicons/vue/24/solid";

const props = defineProps({
  steps: { type: Array, required: true },
  currentStep: { type: String, required: true },
});

const currentIndex = computed(() => props.steps.findIndex((s) => s.key === props.currentStep));

const statusFor = (index) => {
  if (index < currentIndex.value) return "completed";
  if (index === currentIndex.value) return "current";
  return "upcoming";
};

const circleClasses = (index) => {
  const status = statusFor(index);
  if (status === "completed") return "bg-indigo-600 shadow-sm";
  if (status === "current")
    return "bg-indigo-600 shadow-[0_0_0_4px_rgba(99,102,241,0.15)] scale-110";
  return "border-2 border-gray-300 bg-white";
};

const numberClasses = (index) => {
  const status = statusFor(index);
  if (status === "current") return "text-white";
  return "text-gray-400";
};

const labelClasses = (index) => {
  const status = statusFor(index);
  if (status === "completed") return "text-gray-700";
  if (status === "current") return "text-indigo-600";
  return "text-gray-400";
};
</script>
